/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_JOB_STATE_ENTITY_NAME = 'exc.jpmam.v1.JpmamJob';
export const excJpmamV1JpmamJobStateEntity = new schema.Entity<ExcJpmamV1JpmamJobState>(EXC_JPMAM_V1_JPMAM_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jpmamJobId' });

